import AsyncSelect from "react-select/async";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { isEmpty } from "lodash";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Icon } from "@iconify/react/dist/iconify.js";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import EmptyData from "../../../components/EmptyData";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import FieldItem from "../../../components/FieldItem";
import TicketUserContext from "../../../context/UserContext/TicketUserContext/TicketUserContext";
import PaymentGateway from "../../../components/PaymentGateway";
import { CreateTicket } from "../../User/TicketsUser/TicketsUser";
import { productPublicContext } from "../../../context/PublicContext/ProductPublicContext/ProductPublicContext";
import { hostname } from "../../../services/configServices/config";
import {
  convertProductTypeToText,
  convertRoleToPath,
  productTypeItems,
} from "../../../utils/enum";
import { createOrderValidation } from "../../../utils/validation/validation";
import { numberSeparate } from "../../../utils";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

const ProductPublic = () => {
  const auth = useSelector((state) => state.auth);

  const { pathname } = useLocation();

  const {
    products,
    setProducts,
    product,
    setProduct,
    setDiscount,
    handleGetProduct,
  } = useContext(productPublicContext);

  useEffect(() => {
    handleGetProduct();
    return () => {
      setProducts([]);
      setProduct({});
      setDiscount({});
    };
  }, [pathname]);

  if (isEmpty(product))
    return (
      <>
        <SiteTitle title="جزئیات محصول" />

        <Card body>
          <EmptyData title="جزئیات محصول یافت نشد" />
        </Card>
      </>
    );

  return (
    <>
      <SiteTitle title={`جزئیات محصول ${product?.title}`} />

      <div className="row gy-4">
        <div className="col-lg-8">
          <div className="card p-0 radius-12 overflow-hidden">
            <div className="card-body p-0">
              <img
                src={
                  product.picture
                    ? `${hostname}${product.picture}`
                    : "/assets/images/empty-image.png"
                }
                alt=""
                className="w-100 h-100 object-fit-cover"
              />
              <div className="p-32">
                <div className="d-flex align-items-center gap-16 justify-content-between flex-wrap mb-24">
                  <span className="px-20 py-6 bg-neutral-100 rounded-pill bg-hover-neutral-300 text-neutral-600 fw-medium">
                    {product.code}
                  </span>

                  <div className="d-flex align-items-center gap-md-3 gap-2 flex-wrap">
                    {!!product.renewalPeriod &&
                      product.type !== productTypeItems[0] && (
                        <div className="d-flex align-items-center gap-8 text-neutral-500 text-lg fw-medium">
                          <i className="ri-calendar-2-line" />
                          تمدید پس از {numberSeparate(
                            product.renewalPeriod
                          )}{" "}
                          روز
                        </div>
                      )}
                    <div className="d-flex align-items-center gap-8 text-neutral-500 text-lg fw-medium">
                      <i className="ri-box-3-line" />

                      {convertProductTypeToText(product.type)}
                    </div>
                    <div className="d-flex align-items-center gap-8 text-neutral-500 text-lg fw-medium">
                      <i className="ri-price-tag-3-line" />
                      {product.price > 0 ? (
                        <span>
                          <ConvertCurrency price={product.price} />
                          <Currency />
                        </span>
                      ) : (
                        <span className="fw-bold">پس از بررسی مدیریت</span>
                      )}
                    </div>
                  </div>
                </div>
                <h3 className="mb-16">{product.title}</h3>
                <p className="text-neutral-500 text-pre-wrap">
                  {product.description}
                </p>
              </div>
            </div>
          </div>
          <div className="card mt-24" id="comment-form">
            <div className="card-header border-bottom">
              <h6 className="text-xl mb-0">ثبت سفارش</h6>
            </div>
            <div className="card-body p-24">
              {isEmpty(auth) ? (
                <div className="alert alert-secondary bg-secondary-50 text-secondary-500 border-secondary-100 py-1 mt-1 text-sm radius-10 d-flex justify-content-between align-items-center">
                  <div className="w-75">برای ثبت سفارش ابتدا وارد شوید</div>
                  <Link
                    to="/auth/login"
                    className="border border-primary-600 bg-primary-50 bg-hover-primary-100 text-primary-600 text-sm radius-8 w-25 text-center py-6"
                  >
                    ورود به سامانه
                  </Link>
                </div>
              ) : (
                <OrderForm />
              )}
            </div>
          </div>
          <div className="card mt-24" id="comment-form">
            <div className="card-header border-bottom">
              <h6 className="text-xl mb-0">ثبت تیکت پشتیبانی</h6>
            </div>
            <div className="card-body">
              {isEmpty(auth) ? (
                <div className="alert alert-secondary bg-secondary-50 text-secondary-500 border-secondary-100 py-1 mt-1 text-sm radius-10 d-flex justify-content-between align-items-center">
                  <div className="w-75">
                    برای ثبت تیکت پشتیبانی ابتدا وارد شوید
                  </div>
                  <Link
                    to="/auth/login"
                    className="border border-primary-600 bg-primary-50 bg-hover-primary-100 text-primary-600 text-sm radius-8 w-25 text-center py-6"
                  >
                    ورود به سامانه
                  </Link>
                </div>
              ) : (
                <TicketUserContext>
                  <CreateTicket product={product?._id} />
                </TicketUserContext>
              )}
            </div>
          </div>
        </div>
        {/* Sidebar Start */}
        <div className="col-lg-4">
          <div className="d-flex flex-column gap-24">
            {/* Search */}
            <div className="card">
              <div className="card-header border-bottom">
                <h6 className="text-xl mb-0">دسته بندی</h6>
              </div>
              <div className="card-body p-24">
                <h6 className="text-xl transition-2">
                  {product.category?.parent && (
                    <>
                      <Link
                        className="text-hover-primary-600"
                        to={`${
                          auth.role ? `/${convertRoleToPath(auth.role)}` : ""
                        }/category/${product.category?.parent?._id}/category`}
                      >
                        {product.category?.parent?.title}
                      </Link>
                      {" / "}
                    </>
                  )}
                  <Link
                    className="text-hover-primary-600"
                    to={`${
                      auth.role ? `/${convertRoleToPath(auth.role)}` : ""
                    }/product/${product.category?._id}/category`}
                  >
                    {product.category?.title}
                  </Link>
                </h6>
              </div>
            </div>
            {/* Latest Blog */}
            <div className="card">
              <div className="card-header border-bottom">
                <h6 className="text-xl mb-0">محصولات مشابه</h6>
              </div>
              <div className="card-body d-flex flex-column gap-24 p-24">
                {isEmpty(products) ? (
                  <EmptyData title="محصولی یافت نشد" />
                ) : (
                  products?.map((_item) => (
                    <div className="d-flex flex-wrap" key={_item._id}>
                      <Link
                        to={`${
                          auth.role ? `/${convertRoleToPath(auth.role)}` : ""
                        }/product/${_item._id}/product`}
                        className="blog__thumb w-100 radius-12 overflow-hidden"
                      >
                        <img
                          src={
                            _item.picture
                              ? `${hostname}${_item.picture}`
                              : "/assets/images/empty-image.png"
                          }
                          alt=""
                          className="w-100 h-100 object-fit-cover"
                        />
                      </Link>
                      <div className="blog__content">
                        <h6 className="mb-8">
                          <Link
                            to={`${
                              auth.role
                                ? `/${convertRoleToPath(auth.role)}`
                                : ""
                            }/product/${_item._id}/product`}
                            className="text-line-2 text-hover-primary-600 text-md transition-2"
                          >
                            {_item.title}
                          </Link>
                        </h6>
                        <p className="text-line-2 text-sm text-neutral-500 mb-0">
                          {_item.description}
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductPublic;

const OrderForm = () => {
  const user = useSelector((state) => state.user);
  const setting = useSelector((state) => state?.meta?.setting);

  const [gateway, setGateway] = useState("");

  const {
    product,
    discount,
    user: selectedUser,
    handleCreateOrder,
  } = useContext(productPublicContext);

  const isDiscount = !isEmpty(discount);

  // Validation
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { isSubmitted },
  } = useForm({
    resolver: yupResolver(createOrderValidation),
  });

  useEffect(() => {
    reset();
  }, []);

  const submitForm = (data) => {
    const requiredFields = product.fields
      .filter((field) => field.isRequired && !data[field.name])
      .map((field) => field.label);

    if (!isEmpty(requiredFields)) return;

    if (!isInventory && !gateway)
      return toastErrorMessage("انتخاب درگاه پرداخت الزامی است");

    handleCreateOrder(data, gateway);
  };

  if (isEmpty(product.fields)) return <EmptyData />;

  const totalPrice = isDiscount ? discount.totalPrice : product.price;
  const tax = totalPrice * (setting?.taxPercent / 100);
  const isInventory = !isEmpty(selectedUser) || user.wallet >= totalPrice;

  return (
    <>
      <SelectUser />
      <form autoComplete="off" onSubmit={handleSubmit(submitForm)}>
        <div className="row">
          {product.fields?.map((_item) => (
            <FieldItem
              control={control}
              watch={watch}
              item={_item}
              key={_item._id}
              isSubmitted={isSubmitted}
            />
          ))}
        </div>
        <input id="product-form" type="submit" className="d-none" />
      </form>
      <DiscountCode />

      {!isInventory && (
        <div className="col-12">
          <div className="mb-20">
            <PaymentGateway value={gateway} onChange={setGateway} />
          </div>
        </div>
      )}
      <hr />
      <Row className="justify-content-between align-items-center mt-3">
        <Col xs={12} sm={6}>
          <div>
            <table className="text-sm">
              <tbody>
                <tr>
                  <td className="pe-64 pb-4">قیمت محصول:</td>
                  <td className="pe-16 pb-4">
                    <span className="text-primary-light fw-bold">
                      {product.price > 0 ? (
                        <>
                          <ConvertCurrency price={product.price} />
                          <Currency />
                        </>
                      ) : (
                        "پس از بررسی مدیریت"
                      )}
                    </span>
                  </td>
                </tr>
                {isDiscount && (
                  <tr>
                    <td className="pe-64 pb-4">تخفیف:</td>
                    <td className="pe-16 pb-4">
                      <span className="text-primary-light fw-bold">
                        <ConvertCurrency price={discount.discountAmount} />
                        <Currency />
                      </span>
                    </td>
                  </tr>
                )}
                {setting?.taxPercent > 0 && (
                  <tr>
                    <td className="pe-64 pb-4">
                      {setting.taxPercent}% مالیات:
                    </td>
                    <td className="pe-16 pb-4">
                      <span className="text-primary-light fw-bold">
                        {product.price > 0 ? (
                          <>
                            <ConvertCurrency price={tax} />
                            <Currency />
                          </>
                        ) : (
                          "پس از بررسی مدیریت"
                        )}
                      </span>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="pe-64 pt-4 border-top">
                    <span className="text-primary-light fw-bold">
                      مبلغ نهایی:
                    </span>
                  </td>
                  <td className="pe-16 pt-4 border-top">
                    <span className="text-primary-light fw-bold">
                      {product.price > 0 ? (
                        <>
                          <ConvertCurrency price={totalPrice + tax} />
                          <Currency />
                        </>
                      ) : (
                        "پس از بررسی مدیریت"
                      )}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={4}>
          <button
            type="button"
            onClick={() => document.getElementById("product-form").click()}
            className="btn btn-primary border border-primary-600 text-md w-100 py-12 radius-8"
          >
            ثبت سفارش
          </button>
        </Col>
      </Row>
    </>
  );
};

const DiscountCode = () => {
  const { discount, setDiscount, handleCheckDiscountCode } =
    useContext(productPublicContext);

  const isDiscount = !isEmpty(discount);

  return (
    <div className="mb-20">
      <form autoComplete="off" onSubmit={handleCheckDiscountCode}>
        <label
          htmlFor="discount-code"
          className="form-label fw-semibold text-primary-light text-sm mb-8"
        >
          کد تخفیف
        </label>
        <div className="input-group" dir="ltr">
          {isDiscount ? (
            <button
              key="delete-code"
              type="button"
              className="btn btn-outline-danger"
              onClick={() => setDiscount({})}
            >
              حذف کد
            </button>
          ) : (
            <button
              key="check-code"
              type="submit"
              className="btn btn-outline-primary"
            >
              اعمال کد
            </button>
          )}
          <input
            disabled={isDiscount}
            type="text"
            name="code"
            defaultValue={discount?.code}
            className="text-end form-control"
            placeholder="کد تخفیف را وارد کنید"
          />
        </div>
      </form>
      {isDiscount && (
        <div className="alert alert-success bg-success-50 text-success-500 border-success-100 py-1 mt-1 text-sm radius-10">
          <div className="d-flex align-items-center gap-2">
            <Icon icon="solar:check-square-broken" />
            <span>
              مبلغ
              <ConvertCurrency price={discount.discountAmount} />
              <Currency />
              از سفارش کسر گردید
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const SelectUser = () => {
  const auth = useSelector((state) => state.auth);
  const loader = useSelector((state) => state.loader);

  const { user, setUser, handleGetUsers } = useContext(productPublicContext);

  if (!auth.isAdmin) return null;

  return (
    <>
      <div className="mb-20">
        <div>
          <label
            htmlFor="user"
            className="form-label fw-semibold text-primary-light text-sm mb-8"
          >
            کاربر
          </label>
          <div className="input-group" dir="ltr">
            <AsyncSelect
              id="user"
              name="user"
              defaultOptions
              openMenuOnFocus
              cacheOptions
              className="react-select-container col"
              classNamePrefix="react-select"
              placeholder="لطفا کاربر را انتخاب نمایید"
              isLoading={loader}
              noOptionsMessage={() => <p>کاربر برای نمایش یافت نشد</p>}
              loadingMessage={() => <p>لطفا منتظر بمانید ...</p>}
              loadOptions={(val, callback) => {
                handleGetUsers(val, callback);
              }}
              onChange={setUser}
              value={user}
              isClearable
            />
            <button
              className={`btn btn${
                isEmpty(user) ? "" : "-outline"
              }-primary btn-sm`}
              onClick={() => setUser({})}
            >
              خودم
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
